
export const mixBy = {
  AREA: 'AREA',
  NUM_OF_UNITS: 'NUMOFUNITS'
}

export const heatingSystems = {
  NO_HEATING: 'No heating',
  GAS_BOILER_RADIATORS: 'Gas boiler & Radiators',
  GAS_BOILER_UNDER_FLOOR: 'Gas boiler & under floor heating',
  ELECTRIC_BOILER_RADIATORS: 'Electric boiler & Radiators',
  ELECTRIC_BOILER_UNDER_FLOOR: 'Electric boiler and underfloor heating',
  ELECTRIC_HVAC: 'Electric(Air conditioning(HVAC / Heat pump))'
}

export const coolingSystems = {
  NO_COOLING: 'No cooling',
  AIR_CONDITIONING: 'Air conditioning'
}
